module.exports = __webpack_public_path__ + "img/csa_button_gobbleberry.5494ed9d.png";